import { FormButtonRow } from '@ksyos/design-system';
import type { IServiceGetOne } from '@frontend/components/interfaces';
import { ProcessEntity, saveTypeEnum } from '@common/enums';
import { CancelButton, SaveButton, SaveSendButton } from '@frontend/components/elements/carePathButtons';

type TooV1ProcedureDiagnosticReportAddEditFooterButtonsProps = {
    isDisabled: boolean;
    isExisting: boolean;
    onCancel: () => Promise<void>;
    onSave: (status: saveTypeEnum) => Promise<void>;
    revertChanges?: () => Promise<void>;
    saveSendButtonRef: React.RefObject<HTMLButtonElement>;
    service: IServiceGetOne;
};

export function TooV1ProcedureDiagnosticReportAddEditFooterButtons({
    isDisabled,
    isExisting,
    onCancel,
    onSave,
    revertChanges,
    saveSendButtonRef,
    service,
}: TooV1ProcedureDiagnosticReportAddEditFooterButtonsProps) {
    return (
        <FormButtonRow>
            <CancelButton
                cancel={onCancel}
                entity={ProcessEntity.procedure}
                isExisting={isExisting}
                key={`${service.code}-cancel`}
                revertChanges={revertChanges}
                serviceCode={service.code}
                serviceType={service.serviceType}
            />
            <SaveButton
                buttonDisabled={isDisabled}
                key={`${service.code}-save`}
                save={async () => {
                    await onSave(saveTypeEnum.draft);
                }}
            />
            <SaveSendButton
                buttonDisabled={isDisabled}
                key={`${service.code}-save-send`}
                saveSend={async () => {
                    await onSave(saveTypeEnum.final);
                }}
                saveSendButtonRef={saveSendButtonRef}
            />
        </FormButtonRow>
    );
}
